<div class="side-bar" id="nav-side" *ngIf="this.company">
  <div class="background-company" [ngStyle]="{'background-image': 'url('+ imgBg +')'}"></div>
  <div class="info-company">
    <div>
      <div class="img-company" (click)="this.openInfoCompany = true">
        <img class="img-company-image" [src]="imgLogo">
      </div>
      <ng-container *ngIf="!this.readOnlyState">
        <span *ngIf="!this.local" class="open-company" [ngStyle]="{'color': this.statusCompany ? 'green' : '#d70000', 'background': this.statusCompany ? '#0080004d' : '#ff000040' }">{{ textStatusCompany }}</span>
      </ng-container>
      
      <!--Visivel se não estiver em modo Readonly-->
      <ng-container *ngIf="!this.readOnlyState">
        <!--Visivel se não for mesa ou comanda-->
        <div class="infos" *ngIf="!this.local">
          <!--Pedido Minimo-->
          <span *ngIf="this.company.configs.minValue != 0">Min {{ this.company.configs.minValue | currency: 'BRL' }}</span>
          <div *ngIf="this.company.configs.minValue != 0 && this.company.companyHours.dataOpen && this.company.companyHours.dataClose"></div>

          <!--Status da loja-->
          <span *ngIf="!this.statusCompany && this.company.companyHours.dataOpen">Abre as {{ this.company.companyHours.dataOpen | timeFormat }}</span>
          <span *ngIf="this.statusCompany && this.company.companyHours.dataClose">Fecha as {{ this.company.companyHours.dataClose | timeFormat }}</span>

          <!--Tempo de preparo Delivery-->
          <ng-container *ngIf="!this.localCounter">
            <div *ngIf="this.timesInfo.delivery.active"></div>
            <span *ngIf="this.timesInfo.delivery.active">{{ this.timesInfo.delivery.label }}</span>
          </ng-container>

          <!--Tempo de preparo Balcão-->
          <ng-container *ngIf="this.localCounter">
            <div *ngIf="this.timesInfo.counter.active"></div>
            <span *ngIf="this.timesInfo.counter.active">{{ this.timesInfo.counter.label }}</span>
          </ng-container>
        </div>
      </ng-container>
      <div class="icons-info" style="left: 0px;" (click)="openInfoCompany = true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
      </div>
      <div class="icons-info" style="right: 0px;" (click)="share()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2-icon lucide-share-2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>
      </div>
    </div>
  </div>

  <div class="menu-side-bar" [ngClass]="{'local': this.local, 'readOnly': this.readOnlyState}">
      <ul>
        <ng-container *ngFor="let category of tabela; let i = index">
          <ng-container *ngIf="(category.products | filtro: filter : 'name').length > 0">
            <li>
              <a class="links-navegation" (click)="clicked = true; colorBarClick($event, i);" #meulink>{{ category.categoryName }} <i class="fa-solid fa-chevron-right chevron-side active"></i></a>
            </li>
          </ng-container>
        </ng-container>
      </ul>
  </div>
</div>

<app-info-company [openInfo]="this.openInfoCompany" (closeInfo)="this.openInfoCompany = false; this.scrollService.enableScroll()"></app-info-company>
